module.exports = __webpack_public_path__ + "static/media/goldenprize-tuna-tomato-lid.3f8c53b1.png";